<template>
  <div>
    <v-list>
      <v-list-tile>
        <v-list-tile-action>
          <v-btn color="accent"
                 fab small
                 @click="$emit('open-timeline', settlementItem)">
            <v-icon class="pa-2">chat</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Settlement History</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-action>
          <v-update-settlement-btn small fab
                                   v-if="showSettlementUpdateButton(settlementItem)"
                                   :disabled="!!settlementItem.invoiceNumber"
                                   :settlement="settlementItem"
                                   color="accent"
                                   @refresh="$emit('refresh')">
            <template slot="default">
              <v-icon color="white">edit</v-icon>
            </template>
          </v-update-settlement-btn>

        </v-list-tile-action>
        <v-list-tile-content class="pl-2">
          <V-list-tile-title>Update Settlement Details</V-list-tile-title>
          <v-list-tile-sub-title>
            <span class="font-weight-light font-italic">
              Adjust Amount, {{ $t('terms.bill-of-lading') }} Number, Head Count
            </span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="!$vuetify.breakpoint.smAndDown">
          <v-btn flat color="accent" class="pl-1 pr-1" @click="requestRedoBillOfLading">
            <v-layout column>
              <v-icon class="pr-2">refresh</v-icon>
              Redo BoL
            </v-layout>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>

    <v-list-tile avatar>
      <v-list-tile-action>
        <v-quickbooks-billing-btn v-if="shouldDisplayQuickbooksBillingButton"
                                  :disabled="disableQbButton"
                                  :loading="loading"
                                  :invoicing-company="invoicingCompany"
                                  :settlement="settlementItem"/>
      </v-list-tile-action>
      <v-list-tile-content class="pl-2">
        <v-list-tile-title>
          <b>{{invoice.paidTo.name}}</b>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{settlementItem.description}}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title>
          ${{settlementItem.amount}}
          <span class="font-italic">
                        billed to {{invoice.billedTo.name}}
        </span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action v-if="!$vuetify.breakpoint.smAndDown">
        <v-list-tile-action-text>
          <v-chip v-if="_.get(settlementItem, 'status', false)"
                  color="primary" text-color="white" small>
            <v-avatar>
              <v-icon class="pl-2" color="white">
                receipt
              </v-icon>
            </v-avatar>
            {{_.get(settlementItem, 'status')}}
          </v-chip>
        </v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>
    </v-list>

    <v-card v-if="$vuetify.breakpoint.smAndDown">
     <v-card-actions>
       <v-chip v-if="_.get(settlementItem, 'status', false)"
               color="primary" text-color="white" small>
         <v-avatar><v-icon color="white">receipt</v-icon></v-avatar>
         {{_.get(settlementItem, 'status')}}
       </v-chip>
       <v-spacer></v-spacer>
       <v-btn flat color="accent" class="pl-1 pr-1" @click="requestRedoBillOfLading">
         <v-icon class="pr-2">refresh</v-icon>
         Redo BoL
       </v-btn>
     </v-card-actions>
   </v-card>

  </div>
</template>

<script>
import _ from 'lodash';
import * as Settlements from '@/types/models/settlement';
import VQuickbooksBillingBtn from '@/components/qb/QuickbooksBillingButton';
import QuickbooksMixin from '@/mixins/quickbooksMixin';
import SettlementMixin from '@/mixins/settlementMixin';
import InvoicingMixin from '@/mixins/invoicingMixin';
import VUpdateSettlementBtn from '@/components/settlement/UpdateSettlementDetails';
import API from '@/api';

export default {
  name: 'SettlementCard',
  mixins: [
    InvoicingMixin,
    QuickbooksMixin,
    SettlementMixin,
  ],
  components: {
    VQuickbooksBillingBtn,
    VUpdateSettlementBtn,
  },
  props: {
    settlementItem: {
      type: Object,
      required: true,
    },
    invoicingCompany: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _() {
      return _;
    },
    shouldDisplayBillingButton() {
      return this.currentUserHasCreateSettlementInvoicePermission(this.settlementItem) &&
        this.isConnectedToOnlineInvoicing(this.invoicingCompany)
        ;
        // this.isQuickbooksEnabled(this.invoicingCompany) &&
    },
    shouldDisplayQuickbooksBillingButton() {
      return this.shouldDisplayBillingButton &&
        this.isQuickbooksConnected(this.invoicingCompany);
    },
    shouldDisplayXeroBillingButton() {
      return this.shouldDisplayBillingButton &&
        this.isXeroConnected(this.invoicingCompany);
    },
    invoice() {
      return Settlements.invoice(this.settlementItem);
    },
    disableQbButton() {
      const status = _.get(this.settlementItem, 'status', null);
      return status && status !== 'OPEN' && status !== 'INITIALIZED';
    },
  },
  methods: {
    async requestRedoBillOfLading() {
      this.loadingBtn = true;
      try {
        await API.load.redoBOL({ loadId: this.settlementItem.loadHumanId });
      } finally {
        this.loadingBtn = false;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/simple/SettlementCard.vue